import { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import AppBar from "@mui/material/AppBar";
import Typography from "@mui/material/Typography";
import AccountCircle from "@mui/icons-material/AccountCircle";
import IconButton from "@mui/material/IconButton";
import Home from "@mui/icons-material/Home";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import useAuth from "../../hooks/useAuth";
import { toast } from "react-toastify";
import Notification from "../Notification/Notification";
import { jwtDecode } from "jwt-decode";
import { useCan } from "../../hooks/useCan";

const Layout = () => {
  const { auth, setAuth } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  const canReadUser = useCan("User", "read");
  const canReadRol = useCan("Rol", "read");
  const userName = auth?.userName;
  const role = auth?.role;

  const token = auth?.accessToken || localStorage.getItem("accessToken");

  const navigate = useNavigate();

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleClose();
    setAuth({ accessToken: null });
    localStorage.removeItem("accessToken");
    if (!localStorage.getItem("accessToken")) {
      toast.success("Se ha deslogueado correctamente");
    } else {
      toast.error("Hubo un error al intentar desloguearse");
    }
    navigate("/");
  };

  const handleUsuarios = () => {
    navigate("/users");
    handleClose();
  };

  const handleDashboard = () => {
    navigate("/");
  };

  const handleShowUser = () => {
    navigate("/user/profile");
  };

  const handleRolesAndPermissions = () => {
    navigate("/user/new_rol_managment");
  };
  const handleGeneralSettings = () => {
    navigate("/user/general_settings");
  };

  useEffect(() => {
    const handleUnauthorized = () => {
      setAuth({ accessToken: null });
      localStorage.removeItem("accessToken");
      toast.error("Tu sesión ha expirado. Iniciá sesión de nuevo.");
      navigate("/login");
    };

    window.addEventListener("unauthorized", handleUnauthorized);

    return () => {
      window.removeEventListener("unauthorized", handleUnauthorized);
    };
  }, [navigate, setAuth]);

  useEffect(() => {
    const handleForbidden = () => {
      navigate("/access-denied");
    };

    window.addEventListener("forbidden", handleForbidden);

    return () => {
      window.removeEventListener("forbidden", handleForbidden);
    };
  }, []);

  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static">
          <Toolbar variant="dense">
            <Typography
              variant="h6"
              color="inherit"
              component="div"
              sx={{ flexGrow: 1 }}
            >
              Plataforma
            </Typography>

            <IconButton
              size="large"
              aria-label="dashboard"
              aria-haspopup="true"
              color="inherit"
              onClick={handleDashboard}
            >
              <Home />
            </IconButton>

            <Notification />

            <IconButton
              size="large"
              aria-label="account of current user"
              aria-haspopup="true"
              color="inherit"
              onClick={handleMenu}
            >
              <Typography
                variant="body1"
                color="inherit"
                sx={{ marginRight: 2 }}
              >
                {userName} ({role})
              </Typography>
              <AccountCircle />
            </IconButton>
            <Menu
              sx={{ mt: "30px" }}
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              {role === "admin"
                ? [
                    <MenuItem key="profile" onClick={handleShowUser}>
                      Mi Perfil
                    </MenuItem>,
                    <MenuItem key="users" onClick={handleUsuarios}>
                      Usuarios
                    </MenuItem>,
                    <MenuItem
                      key="roles_permissions"
                      onClick={handleRolesAndPermissions}
                    >
                      Crear roles y asignar permisos
                    </MenuItem>,
                    <MenuItem key="general_settings" onClick={handleGeneralSettings}>
                      Configuración General
                    </MenuItem>,
                  ]
                : [
                    <MenuItem key="profile" onClick={handleShowUser}>
                      Mi Perfil
                    </MenuItem>,
                  ]}
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
          </Toolbar>
        </AppBar>
      </Box>

      <Outlet />
    </>
  );
};

export default Layout;
